import axios from "axios";

export default {
    getTaskOrders: async (start_date, end_date) => {
        const { data } = await axios.get('/task_order', {
            params: {
                start_date,
                end_date
            }
        })

        return data
    },
    postTaskOrders: async (sorted_task_ids_list, date) => {
        const { data } = await axios.post('/task_order', {
            sorted_task_ids_list,
            date
        })

        return data
    }
}
